export const SHORT_PREVIEW_CARD_TYPES = {
  BALANCE: 'BALANCE',
  DEBTOR: 'DEBTOR',
  CREDITOR: 'CREDITOR',
  CARBON: 'CARBON',
};
